import type { GenericQA } from '@/models/generic.model';

export const privacyGuaranteed: GenericQA[] = [
  {
    question: 'Do I have control over my genetic information?',
    answer: [
      'Absolutely. We give you control over your genetic information including how it’s used, shared, and when it is deleted.',
    ],
  },
  {
    question: 'Is my DNA data secure?',
    answer: [
      'Yes. We use robust data security measures to safeguard your genetic information. Your DNA sample and genetic information are secure with Alter and our CLIA-certified, CAP-accredited Laboratory Partner.',
    ],
  },
  {
    question: 'Can I delete my DNA from your system?',
    answer: [
      'Yes. The results of your DNA test are stored in a secured database. Your DNA sample is automatically destroyed after testing and quality control checks. You can also ask us to delete your data from our systems anytime.',
    ],
  },
  {
    question: 'Will my DNA be used for research?',
    answer: ['No. We will not use your genetic information for research.'],
  },
];
